const CACHE_KEYS = {
  STATS: 'directory_stats',
  DEFAULT_LISTINGS: 'directory_default_listings',
  CATEGORIES: 'directory_categories',
};

const DEFAULT_STATS = {
  totalSitesPublished: 0,
  totalSites: 0,
};

export const getStatsFromCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEYS.STATS);
    return cached ? JSON.parse(cached) : DEFAULT_STATS;
  } catch (error) {
    return DEFAULT_STATS;
  }
};

export const setStatsInCache = (stats) => {
  try {
    localStorage.setItem(CACHE_KEYS.STATS, JSON.stringify(stats));
  } catch (error) {
    console.error('Failed to cache stats:', error);
  }
};

export const getDefaultListingsFromCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEYS.DEFAULT_LISTINGS);
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    return null;
  }
};

export const setDefaultListingsInCache = (listingsData, featuredListings = []) => {
  try {
    const cacheData = {
      ...listingsData,
      featuredListings
    };
    localStorage.setItem(CACHE_KEYS.DEFAULT_LISTINGS, JSON.stringify(cacheData));
  } catch (error) {
    console.error('Failed to cache listings:', error);
  }
};

export const getCategoriesFromCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEYS.CATEGORIES);
    return cached ? JSON.parse(cached) : ["All Categories"];
  } catch (error) {
    return ["All Categories"];
  }
};

export const setCategoriesInCache = (categories) => {
  try {
    localStorage.setItem(CACHE_KEYS.CATEGORIES, JSON.stringify(categories));
  } catch (error) {
    console.error('Failed to cache categories:', error);
  }
};
